import {
  RE_FILE_MENTION_UNESCAPED_PATH_WITH_SPACE,
  RE_PROFILE_MENTION_USERNAME_WITH_SPACE
} from "@/components/Markdown/mentions.ts"

import type { CompletedEntity } from "@/components/PromptInput/Completion/CompletionModel.ts"


export function parsePartiallyCompletedEntity(text: string, offset: number): CompletedEntity | null {
  if (text[offset] === "@") {
    return parseUsernameOrFilePathEscaped(text, offset + 1)
  } else {
    return null
  }
}

function parseUsernameOrFilePathEscaped(text: string, offset: number): CompletedEntity | null {
  if (text.startsWith("file:", offset)) {
    return parseFilePathEscaped(text, offset - 1, offset + "file:".length)
  } else {
    const regexPrefix = parseRegexPrefix(text, offset, RE_PROFILE_MENTION_USERNAME_WITH_SPACE)
    return {
      type: "profile",
      completedText: text.substring(offset - 1, regexPrefix.entityTextRange[1]),
      completedTextRange: [offset - 1, regexPrefix.entityTextRange[1]],
      ...regexPrefix
    }
  }
}

function parseFilePathEscaped(text: string, completionRangeStart: number, offset: number): CompletedEntity | null {
  let end: number | null = null
  if (text.startsWith("'", offset)) {
    end = text.indexOf("'", offset + 1) - 1
  } else if (text.startsWith("\"", offset)) {
    end = text.indexOf("\"", offset + 1) - 1
  }
  if (end !== null) {
    end = end >= 0 ? end : text.length
    return {
      type: "file",
      completedText: text.substring(completionRangeStart, Math.min(text.length, end + 1)),
      completedTextRange: [completionRangeStart, Math.min(text.length, end + 1)],
      entityText: text.substring(offset + 1, end),
      entityTextRange: [offset + 1, end]
    }
  } else {
    return parseFilePathUnescaped(completionRangeStart, text, offset)
  }
}

function parseFilePathUnescaped(completionRangeStart: number, text: string, offset: number): CompletedEntity | null {
  const regexPrefix = parseRegexPrefix(text, offset, RE_FILE_MENTION_UNESCAPED_PATH_WITH_SPACE)
  return {
    type: "file",
    completedText: text.substring(completionRangeStart, regexPrefix.entityTextRange[1]),
    completedTextRange: [completionRangeStart, regexPrefix.entityTextRange[1]],
    ...regexPrefix
  }
}

function parseRegexPrefix(text: string, offset: number, regex: RegExp): {
  entityText: string,
  entityTextRange: [number, number]
} {
  const match = text.substring(offset).match(regex)
  if (match && text.startsWith(match[0], offset)) {
    return {
      entityText: match[0],
      entityTextRange: [offset, offset + match[0].length]
    }
  } else {
    return {
      entityText: "",
      entityTextRange: [offset, offset]
    }
  }
}
